// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createA2PRegistrationInfoRequestToJson, deleteA2PRegistrationInfoRequestToJson, getA2PRegistrationInfoRequestToJson, getA2PRegistrationInfoResponseFromJson, getAuthorizedRepresentativeStateRequestToJson, getAuthorizedRepresentativeStateResponseFromJson, getLatestA2PRegistrationStatusRequestToJson, getLatestA2PRegistrationStatusResponseFromJson, triggerA2PRegistrationRequestToJson, updateA2PRegistrationStatusRequestToJson, updateA2PRegistrationStatusResponseFromJson, updateAuthorizedRepresentativeRequestToJson, updateAuthorizedRepresentativeResponseFromJson, upsertA2PRegistrationInfoRequestToJson, upsertRejectionAssessmentRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createA2PRegistrationInfo(request) {
    await fetchRpc('sms.v2.A2PRegistration/CreateA2PRegistrationInfo', createA2PRegistrationInfoRequestToJson(request));
}
export function createA2PRegistrationInfo$(request, options) {
    return defer(() => createA2PRegistrationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function createA2PRegistrationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/CreateA2PRegistrationInfo', createA2PRegistrationInfoRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getA2PRegistrationInfo(request) {
    const raw = await fetchRpc('sms.v2.A2PRegistration/GetA2PRegistrationInfo', getA2PRegistrationInfoRequestToJson(request));
    return getA2PRegistrationInfoResponseFromJson(raw);
}
export function getA2PRegistrationInfo$(request, options) {
    return defer(() => getA2PRegistrationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function getA2PRegistrationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/GetA2PRegistrationInfo', getA2PRegistrationInfoRequestToJson(request), options)
        .pipe(map(resp => getA2PRegistrationInfoResponseFromJson(resp)));
}
export async function deleteA2PRegistrationInfo(request) {
    await fetchRpc('sms.v2.A2PRegistration/DeleteA2PRegistrationInfo', deleteA2PRegistrationInfoRequestToJson(request));
}
export function deleteA2PRegistrationInfo$(request, options) {
    return defer(() => deleteA2PRegistrationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function deleteA2PRegistrationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/DeleteA2PRegistrationInfo', deleteA2PRegistrationInfoRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function upsertA2PRegistrationInfo(request) {
    await fetchRpc('sms.v2.A2PRegistration/UpsertA2PRegistrationInfo', upsertA2PRegistrationInfoRequestToJson(request));
}
export function upsertA2PRegistrationInfo$(request, options) {
    return defer(() => upsertA2PRegistrationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function upsertA2PRegistrationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/UpsertA2PRegistrationInfo', upsertA2PRegistrationInfoRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getLatestA2PRegistrationStatus(request) {
    const raw = await fetchRpc('sms.v2.A2PRegistration/GetLatestA2PRegistrationStatus', getLatestA2PRegistrationStatusRequestToJson(request));
    return getLatestA2PRegistrationStatusResponseFromJson(raw);
}
export function getLatestA2PRegistrationStatus$(request, options) {
    return defer(() => getLatestA2PRegistrationStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getLatestA2PRegistrationStatusWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/GetLatestA2PRegistrationStatus', getLatestA2PRegistrationStatusRequestToJson(request), options)
        .pipe(map(resp => getLatestA2PRegistrationStatusResponseFromJson(resp)));
}
export async function triggerA2PRegistration(request) {
    await fetchRpc('sms.v2.A2PRegistration/TriggerA2PRegistration', triggerA2PRegistrationRequestToJson(request));
}
export function triggerA2PRegistration$(request, options) {
    return defer(() => triggerA2PRegistrationWithTransport$(getGlobalTransport(), request, options));
}
export function triggerA2PRegistrationWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/TriggerA2PRegistration', triggerA2PRegistrationRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function updateA2PRegistrationStatus(request) {
    const raw = await fetchRpc('sms.v2.A2PRegistration/UpdateA2PRegistrationStatus', updateA2PRegistrationStatusRequestToJson(request));
    return updateA2PRegistrationStatusResponseFromJson(raw);
}
export function updateA2PRegistrationStatus$(request, options) {
    return defer(() => updateA2PRegistrationStatusWithTransport$(getGlobalTransport(), request, options));
}
export function updateA2PRegistrationStatusWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/UpdateA2PRegistrationStatus', updateA2PRegistrationStatusRequestToJson(request), options)
        .pipe(map(resp => updateA2PRegistrationStatusResponseFromJson(resp)));
}
export async function upsertRejectionAssessment(request) {
    await fetchRpc('sms.v2.A2PRegistration/UpsertRejectionAssessment', upsertRejectionAssessmentRequestToJson(request));
}
export function upsertRejectionAssessment$(request, options) {
    return defer(() => upsertRejectionAssessmentWithTransport$(getGlobalTransport(), request, options));
}
export function upsertRejectionAssessmentWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/UpsertRejectionAssessment', upsertRejectionAssessmentRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getAuthorizedRepresentativeState(request) {
    const raw = await fetchRpc('sms.v2.A2PRegistration/GetAuthorizedRepresentativeState', getAuthorizedRepresentativeStateRequestToJson(request));
    return getAuthorizedRepresentativeStateResponseFromJson(raw);
}
export function getAuthorizedRepresentativeState$(request, options) {
    return defer(() => getAuthorizedRepresentativeStateWithTransport$(getGlobalTransport(), request, options));
}
export function getAuthorizedRepresentativeStateWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/GetAuthorizedRepresentativeState', getAuthorizedRepresentativeStateRequestToJson(request), options)
        .pipe(map(resp => getAuthorizedRepresentativeStateResponseFromJson(resp)));
}
export async function updateAuthorizedRepresentative(request) {
    const raw = await fetchRpc('sms.v2.A2PRegistration/UpdateAuthorizedRepresentative', updateAuthorizedRepresentativeRequestToJson(request));
    return updateAuthorizedRepresentativeResponseFromJson(raw);
}
export function updateAuthorizedRepresentative$(request, options) {
    return defer(() => updateAuthorizedRepresentativeWithTransport$(getGlobalTransport(), request, options));
}
export function updateAuthorizedRepresentativeWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.A2PRegistration/UpdateAuthorizedRepresentative', updateAuthorizedRepresentativeRequestToJson(request), options)
        .pipe(map(resp => updateAuthorizedRepresentativeResponseFromJson(resp)));
}
